export default __webpack_public_path__ + "static/media/united-kingdom.271087da.svg";